<template>
    <v-flex class="education" v-if="educationDetails.length>0 || isCurrentUser">
        <v-layout>
            <v-flex xs6 tag="h2">{{memberProfileConstants.EDUCATION.EDUCATION}}<i v-if="educationDetails.length>0 && isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id="education_open_view" @click="openEducationView()"></i>
                <i v-if="!educationDetails.length>0 && isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id="education_open" @click="openEducationDialog()"></i>
            </v-flex>
            <v-flex class="prefer-say" v-if="isCurrentUser">
                <v-checkbox class="mt-0" color="primary" v-model="contactInformation.declinedToDiscloseEducation" @change="savePreferNotToSay()" :disabled="isEducationCountlessthan1()" :label=memberProfileConstants.EDUCATION.PREFER></v-checkbox>
            </v-flex>
        </v-layout>
        <status-overlay :action="loadGetEducationDetailsAction" content-height="200px">
        </status-overlay>
        <v-flex v-if="!educationDetails.length>0 && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.EDUCATION}} </v-flex>
        <v-flex v-for="(education, index) in educationDetails" :key="index">
            {{education.name}}
            <v-flex tag="strong">{{education.degreeType}} {{education.fieldOfStudy ? memberProfileConstants.FIELD_OF_STUDY_IN : ''}} {{education.fieldOfStudy}}</v-flex>
        </v-flex>
        <v-dialog scrollable v-model="educationDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.EDUCATION.EDIT_EDUCATION}}
                    <i class="fas fa-times" data-qe-id="education_edit_close" @click="educationDialog = false"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar" ref="educationViewDialog">
                    <v-flex v-for="educationKey in Object.keys(educationView).sort()" :key="educationKey" class="details-view">
                        <v-flex tag="h6">{{educationKey}}</v-flex>
                        <v-flex class="row__list" v-for="(education, index) in educationView[educationKey]" :key="index">
                            <v-flex tag="small">{{education.name}} <i class="fas fa-pencil-alt" :data-qe-id="'editEducation_school/college_' +index" @click="editEducation(education)"></i></v-flex>
                            <v-flex tag="strong" v-if="education.degreeType || education.fieldOfStudy">{{education.degreeType}} {{education.fieldOfStudy ? memberProfileConstants.FIELD_OF_STUDY_IN : ''}} {{education.fieldOfStudy}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="btn-row">
                        <v-btn
                            class="primary_btn"
                            v-if="isEducationCountMoreThanOrEqualTo5()"
                            data-qe-id="editEducation_addMore"
                            @click="openEducationDialog()"><i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}</v-btn>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn class="primary_btn" data-qe-id="editEducation_closeBtn1" @click="closeEducationView()">
                            {{appCommonConstants.CLOSE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="educationDetailsDialog" content-class="medium">
            <v-card class="myprofile-popup" id="educationDetails" v-if="educationDetailsDialog">
                <v-card-title primary-title>
                    {{memberProfileConstants.EDUCATION.EDIT_EDUCATION}}
                    <i class="fas fa-times" data-qe-id="editEducation_closeBtn1" @click="cancel()"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar" ref="educationDialogId">
                    <v-flex v-for="(education, index) in educations" :key="index" class="education-details">
                        <v-form
                            :id="index"
                            lazy-validation
                            :ref="`education_${education.id}`"
                            v-model="valid">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.EDUCATION.SCHOOL_TYPE}} {{memberProfileConstants.ASTERISK}}</span>
                                        <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                                        <v-select
                                            attach
                                            v-model="education.type"
                                            :data-qe-id="'editMyEducation_schoolType_' +index"
                                            :rules="memberProfileConstants.EDUCATION.PLEASE_ENTER_SCHOOL_TYPE"
                                            color="ypo_blue"
                                            :items="schoolTypes"
                                            item-text="schoolType1"
                                            item-value="schoolType1"
                                            v-on:input="edit(education)"
                                            required>
                                        </v-select>
                                        <span class="select-label">{{memberProfileConstants.EDUCATION.SCHOOL_NAME}} {{memberProfileConstants.ASTERISK}}</span>
                                        <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen=false">
                                            <v-text-field
                                                required
                                                :data-qe-id="'editMyEducation_schoolName_' +index"
                                                :placeholder="memberProfileConstants.TYPE_TO_SEARCH"
                                                :rules="memberProfileConstants.EDUCATION.PLEASE_ENTER_SCHOOL_NAME"
                                                :maxlength="memberProfileConstants.MAX_NAME_LENGTH"
                                                v-model="education.name"
                                                color="ypo_blue"
                                                @input="fetchEntriesDebounce(education)"
                                                @keydown.down="onArrowDown"
                                                @keydown.up="onArrowUp"
                                                @keydown.enter="onEnter(education)">
                                            </v-text-field>
                                            <v-list
                                                v-show="search.length >= memberProfileConstants.THREE && results.length && education.isSearch && isSearchOpen"
                                                id="autocomplete-results"
                                                ref="autocomplete_results"
                                                class="autocomplete-results">
                                                <v-list-tile
                                                    class="autocomplete-result"
                                                    v-for="(result, i) in results"
                                                    :key="i"
                                                    :data-qe-id="`education-school-name_result_${i}`"
                                                    @click="setResult(result, education)"
                                                    :class="{ 'is-active': i === arrowCounter }">
                                                    <v-list-tile-title v-highlight="{keyword: education.name, sensitive: false}">
                                                        {{ result }}
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                        <span class="select-label" v-if="education.type !== memberProfileConstants.EDUCATION.HIGH_SCHOOL">{{memberProfileConstants.EDUCATION.DEGREE_TYPE}}</span>
                                        <v-autocomplete
                                            attach
                                            v-if="education.type !== memberProfileConstants.EDUCATION.HIGH_SCHOOL"
                                            v-model="education.degreeType"
                                            :data-qe-id="'editMyEducation_degreeType_' +index"
                                            :placeholder="memberProfileConstants.EDUCATION.DEGREE_TYPE"
                                            color="ypo_blue"
                                            :items="degreeTypes"
                                            item-text="degreeType1"
                                            item-value="degreeType1"
                                            v-on:change="edit(education)">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 v-if="education.type !== memberProfileConstants.EDUCATION.HIGH_SCHOOL">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.EDUCATION.FIELD_OF_STUDY}}</span>
                                        <v-text-field
                                            color="ypo_blue"
                                            :data-qe-id="'editMyEducation_fieldOfStudy_' +index"
                                            :placeholder="memberProfileConstants.EDUCATION.FIELD_OF_STUDY"
                                            v-model="education.fieldOfStudy"
                                            :maxlength="memberProfileConstants.MAX_NAME_LENGTH"
                                            @input="edit(education)">
                                        </v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="education.type !== memberProfileConstants.EDUCATION.HIGH_SCHOOL">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.EDUCATION.GRADUATION_YEAR}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'editMyEducation_gradYear_' +index"
                                            :placeholder="memberProfileConstants.EDUCATION.GRADUATION_YEAR"
                                            :items="getListOfYears()"
                                            v-model="education.graduationYear"
                                            v-on:change="edit(education)"></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 v-if="education.type === memberProfileConstants.EDUCATION.HIGH_SCHOOL">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.EDUCATION.GRADUATION_YEAR}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'editMyEducation_gradYear1_' +index"
                                            :placeholder="memberProfileConstants.EDUCATION.GRADUATION_YEAR"
                                            :items="getListOfYears()"
                                            v-model="education.graduationYear"
                                            v-on:change="edit(education)"></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex class="btn-row">
                                    <v-btn
                                        class="primary_btn"
                                        v-if="!education.isEditDialog && educationDetails.length < memberProfileConstants.EDUCATION.EDUCATION_MAX_COUNT_ADD_MORE"
                                        :disabled="!education.isAdd"
                                        :data-qe-id="'editMyEducation_addMore1__' +index"
                                        @click="addEducation(education)">
                                        <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}}
                                    </v-btn>
                                    <v-btn
                                        v-if="educationDetails.length < memberProfileConstants.EDUCATION.EDUCATION_MAX_COUNT_ADD_MORE || education.isEditDialog"
                                        small
                                        class="primary_btn"
                                        :data-qe-id="'editMyEducation_delete_' +index"
                                        @click="deleteEducation(education.id, index)"
                                        :disabled="education.isDelete">
                                        <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                                    </v-btn>
                                    <v-flex class="save-to-profile" v-model="education.isSuccess" v-if="education.isSuccess">
                                        <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-dialog
                                v-model="deleteInformationDialog"
                                lazy
                                absolute
                                content-class="post-actions">
                                <v-card>
                                    <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                        <v-btn icon @click="deleteInformationDialog=false" data-qe-id="editMyEducation_closeBtn2">
                                            <v-icon size="20">close</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex tag="p">
                                        {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                                    </v-flex>
                                    <v-flex text-xs-right>
                                        <status-bar :action="deleteEducationAction"></status-bar>
                                        <v-btn
                                            flat
                                            @click="deleteInformationDialog = false"
                                            data-qe-id="editMyEducation_cancelBtn2"
                                            class="primary_btn transparent">
                                            {{memberProfileConstants.CANCEL}}
                                        </v-btn>
                                        <v-btn
                                            dark
                                            @click="deleteInformation()"
                                            data-qe-id="editMyEducation_continue"
                                            class="primary_btn">
                                            {{memberProfileConstants.CONTINUE}}
                                        </v-btn>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-form>
                    </v-flex>
                </v-card-text>
                <status-bar :action="editEducationAction"></status-bar>
                <status-bar :action="saveEducationAction"></status-bar>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn class="primary_btn transparent" data-qe-id="editMyEducation_cancelBtn3" @click="cancel()">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            class="primary_btn"
                            :disabled="!valid || isSave"
                            data-qe-id="editMyEducation_doneBtn1"
                            @click="saveEducation()">
                            {{appCommonConstants.DONE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { memberProfileConstants, filterResults } from "./memberProfile.constants.js";
    import { mapState, mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { appCommonConstants } from "../appCommon.constants.js";
    import { getListOfYears } from "../../common/utils/dateTime.js";
    import StatusBar from "../StatusBar/StatusBar";
    import { eventBus } from '../../main';
    import { uuid } from 'vue-uuid';
    import Vue from 'vue';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';

    export default {
        name: "Education",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            filterResults,
            educationDialog: false,
            educationDetailsDialog: false,
            deleteInformationDialog: false,
            uuid: uuid.v1(),
            isOpenEditDialog: false,
            educations: [],
            education: {
                id: null,
                name: '',
                fieldOfStudy: '',
                degreeType: null,
                type: null,
                graduationYear: null,
                isEdit: false,
                isDelete: true,
                isAdd: false,
                isEditDialog: false,
                issearch: false,
            },
            getListOfYears,
            educationView: [],
            results: [],
            isSearchOpen: false,
            search: '',
            isSearchLoading: false,
            arrowCounter: 0,
            postBody: {
                type: null,
                name: null,
            },
            isSave: true,
            educationId: null,
            index: null,
            valid: false,
            timerId: '',
        }),
        components: {
            StatusBar,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getEducationDetails(this.memberId);
            eventBus.$on('educationDialog', (() => {
                this.openEducationDialog();
            }));
        },
        methods: {
            ...mapActions({
                getEducationDetails: `memberProfile/${storeAction.getEducationDetails}`,
                editEducationDetails: `memberProfile/${storeAction.editEducation}`,
                saveEducationDetails: `memberProfile/${storeAction.saveEducation}`,
                deleteEducationDetails: `memberProfile/${storeAction.deleteEducation}`,
                searchEducation: `memberProfile/${storeAction.searchEducation}`,
                getContactInformation: `memberProfile/${storeAction.getContactInformation}`,
            }),
            isEducationCountMoreThanOrEqualTo5() {
                return this.educationDetails.length < this.memberProfileConstants.EDUCATION.EDUCATION_MAX_COUNT;
            },
            isEducationCountlessthan1() {
                return this.educationDetails.length > this.memberProfileConstants.EDUCATION.EDUCATION_MIN_COUNT;
            },
            edit(education) {
                education.isEdit = true;
                if (education.type && education.name && education.name.length <= this.memberProfileConstants.MAX_NAME_LENGTH) {
                    if (education.type === this.memberProfileConstants.EDUCATION.HIGH_SCHOOL || education.fieldOfStudy === null || education.fieldOfStudy.length <= this.memberProfileConstants.MAX_NAME_LENGTH) {
                        this.isSave = false;
                        education.isAdd = true;
                    }
                } else {
                    this.isSave = true;
                    education.isAdd = false;
                }
            },
            openEducationView() {
                this.educationDialog = true;
            },
            closeEducationView() {
                this.$refs.educationViewDialog.scrollTop = 0;
                this.educationDialog = false;
            },
            openEducationDialog() {
                this.educationDetailsDialog = true;
                this.isOpenEditDialog = false;
                this.educations = [];
                this.isSave = true;
                this.education.id = this.generateGUID();
                this.educations.push(Vue.util.extend({}, this.education));
            },
            editEducation(education) {
                this.educations = [{
                    name: education.name,
                    fieldOfStudy: education.fieldOfStudy,
                    degreeType: education.degreeType,
                    type: education.type,
                    graduationYear: Number(education.graduationYear),
                    id: education.id,
                    isEditDialog: true,
                    personId: this.memberId,
                }];
                this.isSave = false;
                this.isOpenEditDialog = true;
                this.educationDetailsDialog = true;
                this.educationId = education.Id;
            },
            addEducation(education) {
                const [ref] = this.$refs[`education_${education.id}`];
                if (ref && typeof ref.validate === 'function' && ref.validate()) {
                    this.isOpenEditDialog = false;
                    education.isEditDialog = false;
                    education.isEdit = false;
                    const postBody = {
                        educations: this.educations,
                        personId: this.memberId,
                        isDeclinedToDiscloseEducation: false,
                    };
                    this.saveEducationDetails(postBody)
                        .then(() => {
                            this.search = '';
                            ref.resetValidation();
                            education.isDelete = false;
                            education.isAdd = true;
                            education.isSuccess = true;
                            education.isSearch = false;
                            education.isEditDialog = true;
                            const index = this.educations.length;
                            //takes a bit for dom to actually update
                            setTimeout(() => {
                                document.getElementById(index).scrollIntoView();
                            }, 100);
                            this.education.id = this.generateGUID();
                            this.educations.push(Vue.util.extend({}, this.education));
                    });
                }
            },
            deleteEducation(educationId, index) {
                this.deleteInformationDialog = true;
                this.educationId = educationId;
                this.index = index;
            },
            saveEducation() {
                const postbody = this.educations.filter(x => x.isEdit === true);
                postbody.forEach((x) => {
                    if (x.id === null) {
                        x.id = this.generateGUID();
                    }
                    if (x.type === this.memberProfileConstants.EDUCATION.HIGH_SCHOOL) {
                        x.fieldOfStudy = null;
                        x.degreeType = null;
                    }
                    const [ref] = this.$refs[`education_${this.educations[0].id}`];
                    if (ref && typeof ref.validate === 'function' && !ref.validate()) {
                        this.isSave = true;
                        return true;
                    }
                });
                if (this.isOpenEditDialog) {
                    const postBody = {
                        educations: this.educations,
                        personId: this.memberId,
                        isDeclinedToDiscloseEducation: false,
                    };
                    this.editEducationDetails(postBody)
                        .then(() => {
                            this.resetValidation();
                            this.educationDetailsDialog = false;
                            this.scrollTop();
                        });
                } else {
                    this.saveEducationAPI(postbody);
                }
            },
            saveEducationAPI(postbody) {
                const body = {
                    educations: postbody.map((o) => { o.personId = this.memberId; return o; }),
                    personId: this.memberId,
                    isDeclinedToDiscloseEducation: false,
                };
                this.saveEducationDetails(body)
                    .then(() => {
                        this.educationDetailsDialog = false;
                        this.getContactInformation(this.memberId);
                        this.educationDialog = this.educationDetails.length !== 0;
                        this.scrollTop();
                    });
            },
            generateGUID() {
                return uuid.v1();
            },
            cancel() {
                this.search = '';
                this.resetValidation();
                this.isSave = true;
                this.educationDetailsDialog = false;
                this.scrollTop();
                this.getEducationDetails(this.memberId)
                    .then(() => {
                        this.educationDialog = this.educationDetails.length !== 0;
                    });
            },
            resetValidation() {
                this.educations.forEach((x) => {
                    const [ref] = this.$refs[`education_${x.id}`];
                    if (ref && typeof ref.resetValidation === 'function') {
                        ref.resetValidation();
                    }
                });
            },
            getSearchResults(education) {
                this.edit(education);
                education.isSearch = true;
                this.search = education.name;
                if (this.search.length >= memberProfileConstants.THREE) {
                    this.postBody.type = education.type;
                    this.postBody.name = this.search;
                    this.searchEducation(this.postBody)
                        .then(() => {
                            this.results = this.filterResults(this.educationSearchResult, this.search);
                            this.isSearchOpen = this.results.length > 0;
                            this.arrowCounter = -1;
                            if (this.$refs.autocomplete_results && this.$refs.autocomplete_results.length > 0) {
                                this.$refs.autocomplete_results[0].$el.scrollTop = 0;
                            }
                        });
                }
            },
            setResult(result, education) {
                education.name = result;
                this.isSearchOpen = false;
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                    if (this.arrowCounter >= 3 && this.$refs.autocomplete_results[0] && this.$refs.autocomplete_results[0].$el) {
                        this.$refs.autocomplete_results[0].$el.scrollTop += 56;
                    }
                } else {
                    this.arrowCounter = 0;
                    if (this.$refs.autocomplete_results[0] && this.$refs.autocomplete_results[0].$el) {
                        this.$refs.autocomplete_results[0].$el.scrollTop = 0;
                    }
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                    if (this.arrowCounter >= 3 && this.$refs.autocomplete_results[0] && this.$refs.autocomplete_results[0].$el) {
                        this.$refs.autocomplete_results[0].$el.scrollTop -= 56;
                    }
                } else {
                    this.arrowCounter = (this.results.length - 1);
                    if (this.$refs.autocomplete_results[0] && this.$refs.autocomplete_results[0].$el) {
                        this.$refs.autocomplete_results[0].$el.scrollTop = this.$refs.autocomplete_results[0].$el.scrollHeight - 56;
                    }
                }
            },
            onEnter(education) {
                education.name = this.results[this.arrowCounter];
                this.isSearchOpen = false;
                this.arrowCounter = -1;
            },
            deleteInformation() {
                const params = {
                    educationId: this.educationId,
                    personId: this.memberId,
                };
                this.deleteEducationDetails(params)
                    .then(() => {
                        this.deleteInformationDialog = false;
                        if (this.index <= 0 && this.educations.length === 1) {
                            this.educationDetailsDialog = false;
                            if (this.educationDetails.length === 0) {
                                this.educationDialog = false;
                            }
                        } else {
                            Vue.delete(this.educations, this.index);
                        }
                        this.scrollTop();
                    });
            },
            scrollTop() {
                if (this.$refs.educationDialogId) {
                    this.$refs.educationDialogId.scrollTop = 0;
                }
            },
            savePreferNotToSay() {
                const postBody = {
                    isDeclinedToDiscloseEducation: this.contactInformation.declinedToDiscloseEducation,
                    personId: this.memberId,
                    educations: [],
                };
                this.saveEducationDetails(postBody);
            },
            fetchEntriesDebounce(education) {
                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.getSearchResults(education);
                }, 500);
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                educationDetails: `memberProfile/${storeGetters.educationDetails}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                schoolTypes: `memberProfile/${storeGetters.schoolTypes}`,
                degreeTypes: `memberProfile/${storeGetters.degreeTypes}`,
                educationSearchResult: `memberProfile/${storeGetters.educationSearchResult}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                contactInformation: `memberProfile/${storeGetters.contactInformation}`,
            }),
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            saveEducationAction() {
                return this.actions[storeAction.saveEducation];
            },
            editEducationAction() {
                return this.actions[storeAction.editEducation];
            },
            deleteEducationAction() {
                return this.actions[storeAction.deleteEducation];
            },
            loadGetEducationDetailsAction() {
                return this.actions[storeAction.getEducationDetails];
            }, 
        },
        watch: {
            educationDetails(val) {
                if (val) {
                    this.educationView = [];
                    val.forEach((x) => {
                        const list = this.educationView[x.type];
                        if (list) {
                            list.push(x);
                        } else {
                            this.educationView[x.type] = [x];
                        }
                    });
                    return this.educationView;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .education {
        border-bottom: 1px solid $ypo-open-blue-gray;
        margin-bottom: 20px;
        padding: 0 20px 10px 20px;
        position: relative;

        h2 {
            color: $ypo_blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            margin-bottom: 20px;
            line-height: 26px;
        }

        strong {
            display: block;
            margin-bottom: 20px;
        }

        &-details {
            border-bottom: 2px solid $ypo-gray;
            margin-bottom: 20px;

            &:last-child {
                border-bottom: none;
                margin-bottom: 0;
            }
        }

        @media (max-width: 1199px){
            padding: 0 0 20px 0;
        } 

        .overlay {
            top: 35px;
        }
    }

    .v-card {

        .select-required {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-left: 560px;
            @media (max-width: 767px) {
                display: none;
            }
        }
    }
</style>
<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .education {
        .prefer-say {
            .v-label {
                font-weight: 400;
                font-size: 14px;
            }
        }
    }
</style>
